import { render, staticRenderFns } from "./ExperimentPatientSelector.vue?vue&type=template&id=df3b83f8&scoped=true&"
import script from "./ExperimentPatientSelector.vue?vue&type=script&lang=ts&"
export * from "./ExperimentPatientSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ExperimentPatientSelector.vue?vue&type=style&index=0&id=df3b83f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b83f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
